import React from "react";
import data from "../data/cta.json";
import { subscriptionFormAction } from "../global";

const Cta = ({ isBg }) => {
  const { cta } = data;
  return (
    <section
      className={`cta section-padding ${isBg === "yes" ? "bg-one" : ""}`}
      id="cta"
      style={{ backgroundImage: `url("${cta.backgroundImage}")` }}
    >
      <div className="container">
        <div className="row justify-content-center cta__inner bg-one">
          <div className="col-lg-8">
            <div className="section-title-center mb-0 text-center">
              <span
              >
                {cta.subtitle}
              </span>
              <h2
                className="display-6"
              >
                {cta.title}
              </h2>
            </div>
            <div className="cta-form-box">
              <form action={subscriptionFormAction.link} method="post">
                <input
                    name="email"
                    className="subscription-email"
                    id="subscription-email"
                    type="email"
                    placeholder="Your Email"
                    required
                  />
                <button className="w-100 button button__primary align-items-center aos-init" type="submit"><span>{cta.btnText}</span></button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cta;
